export const FETCH_TABLE_DATA_START = 'FETCH_TABLE_DATA_START';
export const FETCH_TABLE_DATA_SUCCESS = 'FETCH_TABLE_DATA_SUCCESS';
export const FETCH_TABLE_DATA_ERROR = 'FETCH_TABLE_DATA_ERROR';
